export class MineralInventory {
    all_names: any[] = [];
    amis_id: string;
    assay_sample: any[] = [];
    assessment_work: any[] = [];
    belt: string;
    characteristics: any[] = [];
    classifications: any[] = [];
    comments: any[] = [];
    contact_rgp: any[] = [];
    create_date: string;
    deposit_access_description: string;
    deposit_name: string;
    deposit_status: string;
    domain: string;
    exploration_history: string;
    formation_group: any;
    geochronological_age: any;
    geochronological_age_ref: any;
    geological_age: string;
    intrusion_name: string;
    lat_dec: number;
    lithology: any[] = [];
    ll_datum: string;
    lng_dec: number;
    location_method: string;
    mdi_ident: string;
    metamorphism_grade: any;
    metamorphism_type: any;
    mineral_zones: any[] = [];
    mineralization: any[] = [];
    nts: any[] = [];
    point_location_description: string;
    primary_commodities: any[] = [];
    production: any[] = [];
    province: string;
    references: any[] = [];
    related_deposit_flag: string;
    related_records: any[] = [];
    reserves: any[] = [];
    rgp_district: string;
    secondary_commodities: any[] = [];
    site_visits: any[] = [];
    subprovince: string;
    supergroup: any;
    tectonic_assemblage: any;
    terrane: string;
    townships: any[] = [];
    updated_at: string;
    updated_section: string;
    utm_datum: string;
    utm_easting: number;
    utm_northing: number;
    utm_zone: number;
  
    constructor(init?: Partial<MineralInventory>) {
      Object.assign(this, init);
    }
  }

 